// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__K9LSM {
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  .styles_wrapper__K9LSM {
    padding: 15px;
  }
}

.styles_btnBlock__pkNVQ {
  display: flex;
  gap: 24px;
}
@media (max-width: 992px) {
  .styles_btnBlock__pkNVQ {
    display: none;
  }
}

.styles_btnWrapper__xBsXO {
  width: 200px;
}

.styles_icon__7CsGe {
  width: 70px;
  height: 70px;
  display: flex;
}

.styles_logoText__Tc3Uz {
  display: none;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: #ffffff;
}
@media (max-width: 992px) {
  .styles_logoText__Tc3Uz {
    display: block;
  }
}

.styles_logoBlock__SaRnC {
  display: flex;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/heading/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFF;ACoBE;EDtBF;IAOI,aAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;ACUE;EDXF;IAKI,aAAA;EAAF;AACF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cEvCM;AFuCR;ACdE;EDQF;IASI,cAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  padding: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @include lg {\n    padding: 15px;\n  }\n}\n\n.btnBlock {\n  display: flex;\n  gap: 24px;\n\n  @include lg {\n    display: none;\n  }\n}\n\n.btnWrapper {\n  width: 200px;\n}\n\n.icon {\n  width: 70px;\n  height: 70px;\n  display: flex;\n}\n\n.logoText {\n  display: none;\n  font-weight: 800;\n  font-size: 20px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white;\n\n  @include lg {\n    display: block;\n  }\n}\n\n.logoBlock {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__K9LSM`,
	"btnBlock": `styles_btnBlock__pkNVQ`,
	"btnWrapper": `styles_btnWrapper__xBsXO`,
	"icon": `styles_icon__7CsGe`,
	"logoText": `styles_logoText__Tc3Uz`,
	"logoBlock": `styles_logoBlock__SaRnC`
};
export default ___CSS_LOADER_EXPORT___;
